module.exports = __webpack_public_path__ + "static/media/avatar.a1f8e6e5.png";